import { createGlobalStyle } from 'styled-components';
import colors from './colors';

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    overflow-x: hidden;
    max-width: 100%;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 1.6;
    color: ${colors.text.primary};
    background-color: ${colors.background.white};
    overflow-x: hidden;
  }

  /* Scrollbar personalizada */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${colors.neutral.lightGray};
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.primary.green};
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${colors.primary.blue};
  }

  /* Seleção de texto */
  ::selection {
    background-color: ${colors.primary.green};
    color: white;
  }

  /* Links */
  a {
    color: ${colors.primary.green};
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: ${colors.primary.blue};
    }
  }

  /* Botões */
  button {
    cursor: pointer;
    border: none;
    outline: none;
    font-family: inherit;
  }

  /* Imagens */
  img {
    max-width: 100%;
    height: auto;
  }

  /* Títulos */
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.2;
    margin-bottom: 0.5em;
  }

  /* Parágrafos */
  p {
    margin-bottom: 1em;
  }

  /* Listas */
  ul, ol {
    margin-bottom: 1em;
    padding-left: 1.5em;
  }

  /* Formulários */
  input, textarea, select {
    font-family: inherit;
    font-size: inherit;
  }

  /* Foco */
  *:focus {
    outline: 2px solid ${colors.primary.green};
    outline-offset: 2px;
  }

  /* Animações suaves */
  * {
    transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease;
  }
`;

export default GlobalStyles;
